import {
  Cloud,
  CloudRain,
  CloudSnow,
  CloudDrizzle,
  CloudLightning,
  Sun,
  CloudSun,
  type LucideIcon
} from "lucide-react";

export const getWeatherIcon = (weatherCode: number): LucideIcon => {
  // Thunderstorm (200-232)
  if (weatherCode >= 200 && weatherCode < 300) {
    return CloudLightning;
  }
  
  // Drizzle (300-321)
  if (weatherCode >= 300 && weatherCode < 400) {
    return CloudDrizzle;
  }
  
  // Rain (500-531)
  if (weatherCode >= 500 && weatherCode < 600) {
    return CloudRain;
  }
  
  // Snow (600-622)
  if (weatherCode >= 600 && weatherCode < 700) {
    return CloudSnow;
  }
  
  // Atmosphere (701-781)
  if (weatherCode >= 700 && weatherCode < 800) {
    return Cloud;
  }
  
  // Clear (800)
  if (weatherCode === 800) {
    return Sun;
  }
  
  // Clouds (801-804)
  if (weatherCode > 800 && weatherCode < 810) {
    return weatherCode === 801 ? CloudSun : Cloud;
  }
  
  // Default fallback
  return Cloud;
};
